export default "__VITE_ASSET__jRGhCK76__"